import { ApplicationController } from "stimulus-use";

export default class extends ApplicationController {
  get form() {
    return this.element.querySelector("form");
  }

  async addToCart(ev) {
    ev.preventDefault();

    if (!this.form) {
      throw new Error("No form found");
    }

    const searchParams = new URLSearchParams(window.location.search);

    const data = Object.fromEntries(new FormData(this.form));
    if (searchParams.has("variant")) {
      data.id = searchParams.get("variant");
    }

    const response = await fetch(this.form.action, {
      method: this.form.method,
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
      },
      body: JSON.stringify({
        items: [data],
      }),
    }).then((res) => res.json());

    this.dispatch("added-to-cart", response);

    cartDrawer.show();
  }
}
